import { ajax_getUserInfo } from '@/api/personal'
import store from '@/store'
import * as STORE from '@/store/mutation-types'
import { vm } from '@/main'
import qrcode from 'qrcode'
// 用于用于处理 promise 的正确或错误返回

export const ajaxTry = (p) => {
  return p.then((data) => [true, data]).catch((err) => [false, err])
}

// promise 结果处理工具函数
export function asyncTry(p) {
  return p.then((data) => [true, data]).catch((err) => [false, err])
}

// 用于更新用户信息
export async function updateUserInfo(results) {
  if (Array.isArray(results) && !results[0]) {
    return results
  }
  const data = await ajax_getUserInfo()
  store.commit(STORE.SET_USER_INFO, data)
  return results
}

// 用于验证码的请求结果处理
export const ajaxSmsHandle = async function (ajaxPromise, $event) {
  try {
    await ajaxPromise
    $event.startCount()
  } catch {
    $event.sendFail()
  }
}

// 根据请求结果顺便执行浮窗操作
export function ajaxTip(results) {
  let [flag, res] = results
  if (!res.code) {
    ;[flag, res] = ajaxDataShrink([flag, res])
  }
  if (flag) {
    vm.$Message.success({
      content: res.message,
      duration: 1.5,
    })
  } else {
    vm.$Message.error({
      content: res.message,
      duration: 1.5,
    })
  }
  return results
}

// 根据请求结果顺便执行弹窗操作
export function ajaxAlert(results) {
  let [flag, res] = results
  if (!res.code) {
    ;[flag, res] = ajaxDataShrink([flag, res])
  }

  let okPromise = null
  if (flag) {
    okPromise = new Promise((resolve) => {
      vm.$Modal.success({
        title: res.message,
        onOk: () => {
          resolve()
        },
      })
    })
    results.push(okPromise)
  } else {
    vm.$Modal.error({
      title: res.message,
    })
  }

  return results
}

// 用于去除返回结果中的 data
export function ajaxDataShrink([flag, res]) {
  // 找到下面有 code 属性的对象并返回
  if (res.code) {
    return [flag, res]
  }
  return [flag, res.data]
}

// 用于复制网页文本
export function copyText(text) {
  let inputDom = document.createElement('input')
  inputDom.value = text
  // language=CSS prefix=body{ suffix=}
  inputDom.style.cssText = `
    position: relative;
    bottom: -100px;
  `
  window.document.body.appendChild(inputDom)
  inputDom.select()
  document.execCommand('copy')
  window.document.body.removeChild(inputDom)
}

// 用于返回读取的 blob 类型文件的 base 64
export function asyncReadAsBase64(b) {
  return new Promise((resolve) => {
    let f = new FileReader()
    f.onload = function (res) {
      resolve(res.target.result)
    }
    f.readAsDataURL(b)
  })
}

// 用于生成二维码
export function generateQRCode(dom, str) {
  qrcode.toCanvas(
    dom,
    str,
    {
      width: 140,
    },
    function (error) {
      if (error) {
        // console.error(error)
        return
      }
    }
  )
}

// 用于返回最近几天的日期范围
export function dealDateDays(days, separator = '-') {
  const dealNumber = (num) => {
    if (num < 10) {
      return '0' + num
    } else {
      return num
    }
  }
  const dateInstance = new Date()
  const nowYear = dateInstance.getFullYear()
  const nowMonth = dealNumber(dateInstance.getMonth() + 1)
  const nowDate = dealNumber(dateInstance.getDate())
  const nowTimestamp = dateInstance.getTime()
  const dayTimestamp = 1000 * 60 * 60 * 24
  const targetTimestamp = dayTimestamp * days
  const actionDate = new Date(nowTimestamp - targetTimestamp)
  const lastYear = actionDate.getFullYear()
  const lastMonth = dealNumber(actionDate.getMonth() + 1)
  const lastDate = dealNumber(actionDate.getDate())
  const lastDateResult = lastYear + separator + lastMonth + separator + lastDate
  const nowDateResult = nowYear + separator + nowMonth + separator + nowDate
  return [lastDateResult, nowDateResult]
}

/**
 * 用于处理传入的日期距离现在是几天（或其他时间点）前
 * @params dateString 如：2020-12-07 14:08:50
 * */
export function dealDateBefore(dateString) {
  const minuteTimestamp = 60 * 1000 // 一分钟时间戳
  const hourTimestamp = 60 * 60 * 1000 // 一小时时间戳
  const dayTimestamp = 24 * 60 * 60 * 1000 // 一天时间戳
  const monthTimestamp = 30 * 24 * 60 * 60 * 1000 // 30天时间戳
  const yearTimestamp = 12 * 30 * 24 * 60 * 60 * 1000 // 一年时间戳
  const initArray = dateString.split(' ')
  const one = initArray[0].split('-')
  const two = initArray[1].split(':')
  const resultArray = one.concat(two)
  const targetTimestamp = new Date(
    resultArray[0],
    resultArray[1] - 1,
    resultArray[2],
    resultArray[3],
    resultArray[4],
    resultArray[5]
  ).getTime()
  const nowTimestamp = new Date().getTime()
  const resultTimestamp = nowTimestamp - targetTimestamp
  if (resultTimestamp <= hourTimestamp) {
    for (let i = 1; i < 60; i++) {
      // 发布时间距离现在小于或等于一分钟
      if (i === 1 && resultTimestamp <= minuteTimestamp) {
        return this.$t('刚刚')
      } else if (
        minuteTimestamp * i < resultTimestamp &&
        resultTimestamp <= minuteTimestamp * (i + 1)
      ) {
        // return `${i}分钟前`
        return this.$tc('分钟前', i, { count: i })
      }
    }
  } else if (
    hourTimestamp < resultTimestamp &&
    resultTimestamp <= dayTimestamp
  ) {
    for (let i = 1; i < 24; i++) {
      if (
        hourTimestamp * i < resultTimestamp &&
        resultTimestamp <= hourTimestamp * (i + 1)
      ) {
        // return `${i}小时前`
        return this.$tc('小时前', i, { count: i })
      }
    }
  } else if (
    dayTimestamp < resultTimestamp &&
    resultTimestamp <= monthTimestamp
  ) {
    for (let i = 1; i < 30; i++) {
      if (
        dayTimestamp * i < resultTimestamp &&
        resultTimestamp <= dayTimestamp * (i + 1)
      ) {
        // return `${i}天前`
        return this.$tc('天前', i, { count: i })
      }
    }
  } else if (
    monthTimestamp < resultTimestamp &&
    resultTimestamp <= yearTimestamp
  ) {
    for (let i = 1; i < 12; i++) {
      if (
        monthTimestamp * i < resultTimestamp &&
        resultTimestamp <= monthTimestamp * (i + 1)
      ) {
        // return `${i}月前`
        return this.$tc('月前', i, { count: i })
      }
    }
  } else {
    return initArray[0]
  }
}

// 用于生成 GUID 唯一标识
export function createGuid() {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    const r = (Math.random() * 16) | 0
    const v = c === 'x' ? r : (r & 0x3) | 0x8
    return v.toString(16)
  })
}

// 交易对格式转换
export function tradingPairFormatReverse(tradingPair) {
  if (tradingPair.includes('_')) {
    return tradingPair.toUpperCase().replace('_', '/')
  }
  return tradingPair.toLowerCase().replace('/', '_')
}

// 解析K线周期
export function parseInterval(interval, size = 500, isContract) {
  const timeUnit = isContract ? 1 : 1000
  const fromUnit = isContract ? 1000 : 1
  // size默认返回1440条
  // 获取当前时间戳
  let time = Math.floor(+new Date() / timeUnit)
  // 默认返回对象, 默认根据时间拿一年得对象
  let result
  // 获取字母
  let letter = interval.replace(/[^a-zA-Z]+/g, '')
  // 获取数字
  let num = interval.replace(/[^\d]/g, '')
  // 业务逻辑处理
  switch (letter) {
    case 'm':
    case 'M':
      result = {
        type: num,
        from: time - size * num * 60 * fromUnit,
        to: time,
      }
      break
    case 'h':
    case 'H':
      result = {
        type: 60 * num,
        from: time - size * num * 60 * 60 * fromUnit,
        to: time,
      }
      break
    case 'd':
    case 'D':
      result = {
        type: isContract ? letter : interval,
        from: time - size * 24 * 60 * 60 * fromUnit,
        to: time,
      }
      break
    case 'w':
    case 'W':
      break
    default:
      break
  }
  return result
}
